module.exports = "<div ui-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/entitler/entitler.html
// module id = 381
// module chunks = 1